import type { TRIChemicalIdentificationDataType } from '../../types/form-r.ts';
import type { CasOrCategory } from '../../types/db.ts';

export function formRChemicalIdentification({
  casOrCategory,
  chemicalName,
}: {
  casOrCategory: CasOrCategory;
  chemicalName: string;
}): TRIChemicalIdentificationDataType[] {
  return [
    {
      CASNumber: casOrCategory.replace(/-/g, ''), // For some reason the XML format elides the dashes usually present in CAS numbers.
      ChemicalNameText: chemicalName,
      ChemicalMixtureNameText: 'NA', // We are always providing the chemical name above, so this is not relevant.
      MetalCompoundReportIncludeElementalMetalIndicator: false, // For now, at least, we're always reporting these separately.
      // Lead has higher thresholds if the facility only uses it within stainless, brass, or bronze alloys. We
      // always assume the most-conservative threshold, so if we see lead here, it means we exceeded that threshold:
      LeadExceedsThresholdIndicator:
        casOrCategory === ('N420' as CasOrCategory) || casOrCategory === ('7439-92-1' as CasOrCategory) ? true : null,

      // These only seem to apply if we don't have a CAS, but our system assumes we always have a CAS:
      EPAChemicalIdentifier: null,
      EPAChemicalRegistryName: null,
      EPAChemicalRegistryNameContext: null,

      // These were only reported from 2000 through 2007, so we can safely leave these as all null:
      DioxinDistribution1Percent: null,
      DioxinDistribution2Percent: null,
      DioxinDistribution3Percent: null,
      DioxinDistribution4Percent: null,
      DioxinDistribution5Percent: null,
      DioxinDistribution6Percent: null,
      DioxinDistribution7Percent: null,
      DioxinDistribution8Percent: null,
      DioxinDistribution9Percent: null,
      DioxinDistribution10Percent: null,
      DioxinDistribution11Percent: null,
      DioxinDistribution12Percent: null,
      DioxinDistribution13Percent: null,
      DioxinDistribution14Percent: null,
      DioxinDistribution15Percent: null,
      DioxinDistribution16Percent: null,
      DioxinDistribution17Percent: null,
      DioxinDistributionNAIndicator: null,
    },
  ];
}
